/**
 * /apex route — thin wrapper around the Apex live dashboard.
 *
 * The actual component is `ApexDashboardPage` (was `pages/Dashboard.tsx`
 * pre-M1.0); we keep it untouched and just present it under the new
 * route. Monitor-only build: the dashboard displays live telemetry
 * (probes, outlet states, controller info) with zero write affordances.
 */
import { ApexDashboardPage } from './ApexDashboard';

export function ApexPage() {
  return <ApexDashboardPage />;
}
